// Vistoria do veículo (2026-10-08). Chave "vehicle-inspections" fica fora
// da persistência do React Query (links assinados de foto vencem) — ver
// __root.tsx.
import { useQuery } from "@tanstack/react-query";
import { vehicleInspectionsService } from "@/services/gpsdrive-vehicle-inspections.service";

export const useVehicleInspectionAccess = (enabled = true) =>
  useQuery({
    queryKey: ["vehicle-inspections", "access"],
    queryFn: vehicleInspectionsService.access,
    enabled,
    staleTime: 60_000,
    retry: 1,
  });

export const useMyVehicleInspections = (enabled = true) =>
  useQuery({
    queryKey: ["vehicle-inspections", "mine"],
    queryFn: vehicleInspectionsService.mine,
    enabled,
  });

export const useVehicleInspections = (
  params: { deviceId?: number; userId?: string },
  enabled = true,
) =>
  useQuery({
    queryKey: ["vehicle-inspections", "list", params.deviceId ?? null, params.userId ?? null],
    queryFn: () => vehicleInspectionsService.list(params),
    enabled,
  });

export const useVehicleInspectionTemplate = (enabled = true) =>
  useQuery({
    queryKey: ["vehicle-inspections", "template"],
    queryFn: vehicleInspectionsService.template,
    enabled,
    staleTime: 60_000,
  });
